export default function TextSimpleInput({
                                            placeholder,
                                            name,
                                            onChange = null,
                                            error,
                                            type = 'text',
                                            required = false,
                                            invalidMessage = '',
                                            value = null,
                                            defaultValue = null,
                                            style = null,
                                        }) {
    return <>
        <div><input onInvalid={e => e.target.setCustomValidity(invalidMessage)}
                    onChange={e => e.target.setCustomValidity('')}
                    type={type} value={value} className="form-control" name={name}
                    placeholder={placeholder} required={required} style={style} />
            {error && <p className="text-danger">{error}</p>}
        </div>
        <style>{`
        input::placeholder {
        color: Silver !important;  
        }
      `}</style>
    </>;
}
